import { render, staticRenderFns } from "./CooTranslations.vue?vue&type=template&id=44af89ea&scoped=true&"
import script from "./CooTranslations.vue?vue&type=script&lang=ts&"
export * from "./CooTranslations.vue?vue&type=script&lang=ts&"
import style0 from "./CooTranslations.vue?vue&type=style&index=0&id=44af89ea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44af89ea",
  null
  
)

export default component.exports